import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// Jost is self-hosted (no Google Fonts requests from the kiosk — GDPR). Latin covers PT and EN;
// Cyrillic is for the Russian tablet UI and is downloaded only when Cyrillic text is shown.
import '@fontsource/jost/latin-300.css';
import '@fontsource/jost/latin-400.css';
import '@fontsource/jost/latin-500.css';
import '@fontsource/jost/latin-600.css';
import '@fontsource/jost/latin-700.css';
import '@fontsource/jost/cyrillic-300.css';
import '@fontsource/jost/cyrillic-400.css';
import '@fontsource/jost/cyrillic-500.css';
import '@fontsource/jost/cyrillic-600.css';
import '@fontsource/jost/cyrillic-700.css';
import './index.css';
import App from './App.tsx';
import { manifestOnlyForApp } from './homeScreen';

manifestOnlyForApp();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
